import moment from 'moment';

export const dateFormat = 'YYYY-MM-DD';
export const dayFormat = 'ddd, MMM D, YYYY';

export const castToGMT = (aDate) => new Date(moment.utc(aDate).format(dateFormat));

export const castToLocal = (aDate) => new Date(moment.utc(aDate).format(dayFormat));

export const castToUtcTimestamp = (aDate) => new moment.utc(aDate).format();
